var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2287_134915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 9.99967C8.33325 10.4417 8.50885 10.8656 8.82141 11.1782C9.13397 11.4907 9.55789 11.6663 9.99992 11.6663C10.4419 11.6663 10.8659 11.4907 11.1784 11.1782C11.491 10.8656 11.6666 10.4417 11.6666 9.99967C11.6666 9.55765 11.491 9.13372 11.1784 8.82116C10.8659 8.5086 10.4419 8.33301 9.99992 8.33301C9.55789 8.33301 9.13397 8.5086 8.82141 8.82116C8.50885 9.13372 8.33325 9.55765 8.33325 9.99967Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C15.5 13.3333 13 15 10 15C7 15 4.5 13.3333 2.5 10C4.5 6.66667 7 5 10 5C13 5 15.5 6.66667 17.5 10Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2287_134915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/EyeOpen.a66a67a8530a4aeba578651e79e42e9e.svg";
export { ForwardRef as ReactComponent };